import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Auth from './routes/Auth';
import SelectionStock from './routes/SelectionStock';
import TabList from './routes/TabList';
import store from './store/store';
import PdfViewer from './routes/PdfViewer';
import PieceInfo from './routes/PieceInfo';
import ModalAppContainer from './containers/ModalAppContainer';

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Switch>
          <Route path={'/'} exact component={Auth} />
          <Route path={'/stock'} component={SelectionStock} />
          <Route path={'/tablist/:stockId'} component={TabList} />
          <Route path={'/info/:pieceNumId/:tab'} component={PieceInfo} />
          <Route path={'/info/:pieceNumId'} component={PieceInfo} />
          <Route path={'/pdf-viewer/:data'} component={PdfViewer} />
          <Route render={() => <h3>Page Not Found!</h3>} />
        </Switch>
      </BrowserRouter>
      <ModalAppContainer />
    </Provider>
  );
}

export default App;
